import React from 'react';
import cx from 'classnames';

import NutrientElement from '~/components/lawns/digital-soil-test/nutrient-element';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const Nutrient = ({ name, symbol, description, color, isLimiting }) => {
  return (
    <div className={styles.nutrient}>
      <NutrientElement
        className={styles.nutrientElement}
        color={color}
        name={name}
        symbol={symbol}
      />
      <div className={styles.nutrientTextBlock}>
        <p className={styles.nutrientName}>{name}</p>
        <p className={styles.nutrientDescription}>{description}</p>
      </div>
      {isLimiting ? (
        <div
          className={cx(
            styles.nutrientIndicator,
            styles.nutrientIndicatorInsufficient
          )}
        >
          <img
            className={styles.nutrientIndicatorIcon}
            src="/icons/alert-icon.svg"
            alt="thumbs up"
            width="25"
            height="25"
          />
          <span>Likely needs more nutrients</span>
        </div>
      ) : (
        <div className={styles.nutrientIndicator}>
          <img
            className={styles.nutrientIndicatorIcon}
            src="/icons/thumbs-up-icon.svg"
            alt="thumbs up"
            width="25"
            height="25"
          />
          <span>Soil is likely sufficient</span>
        </div>
      )}
    </div>
  );
};

export default Nutrient;
